import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentError from './AsyncComponentError';
import EmptyComponent from './EmptyComponent';
const AsyncNotInstalledAlert = Loadable({
  loader: () => import( /* webpackChunkName: "not-installed-alert" */'../../verify-install/components/NotInstalledAlert'),
  LoadingComponent: EmptyComponent,
  ErrorComponent: AsyncComponentError
});
export default AsyncNotInstalledAlert;